import { useSelector } from "react-redux";

const formatErrors = errors =>
  errors?.reduce((acc, error) => {
    acc[error.type] = error.messages.join(". ");
    return acc;
  }, {});

export const useContactFormData = () => {
  const contactFormData = useSelector(({ contactForm }) => contactForm);

  return {
    ...contactFormData,
    errors: formatErrors(contactFormData.errors)
  };
};
